import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ mt: 3, textAlign: "center" }}>
      <CheckCircle color="success" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Registration Successful!
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }} color="textSecondary">
        Your company registration has been submitted. You&apos;ll receive a
        confirmation email shortly.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/")} size="large">
        Return to Home
      </Button>
    </Box>
  );
};

export default Confirmation;
